class ClickOutsideController {
  constructor(host, closeFn = null) {
    this.host = host;
    this.closeFn = closeFn;
    this.host.addController(this);
  }
  hostConnected() {
    document.addEventListener("click", this.#handleClickOutside);
  }
  hostDisconnected() {
    document.removeEventListener("click", this.#handleClickOutside);
  }
  #handleClickOutside = (e) => {
    if (!e.composedPath().includes(this.host)) {
      if ("opened" in this.host && !this.closeFn) {
        this.host.opened = false;
      } else if (this.closeFn) {
        this.closeFn(e);
      } else {
      }
    }
  };
}
export {
  ClickOutsideController
};
//# sourceMappingURL=click-outside-controller.js.map
